import { combineReducers } from '@reduxjs/toolkit'

import {
  CURRENT_ROOT_ID_REDUCER_NAME,
  ROOT_DOMAINS_DATA_REDUCER_NAME,
} from './consts'

import { currentRootIdSlice, rootDomainsDataReducer } from './slice'

export default combineReducers({
  [ROOT_DOMAINS_DATA_REDUCER_NAME]: rootDomainsDataReducer,
  [CURRENT_ROOT_ID_REDUCER_NAME]: currentRootIdSlice.reducer,
})
